const field = {
  inject: ['parentValidator'],
  provide() {
    return { parentValidator: this.parentValidator };
  },
};

export { field as default };
